export const normalizeAreasFromBackend = (areas: any[], squareFt: number) => {
  return (areas ?? []).map((a: any) => {
    const sq = Array.isArray(a.squareFootages) ? a.squareFootages : [];
    const first = sq[0] ?? { squareFt, quantity: 0 };

    const quantity = Number(a.quantity ?? first.quantity ?? 0);

    const tasks = Array.isArray(a.tasks) ? a.tasks : [];
    const normalizedTasks = tasks?.map((t: any) => ({
      ...t,
      // keep ids consistent
      uid: t.uid ?? t.id,
      // IMPORTANT: guarantee boolean active
      // If backend already sends active => keep it
      // If not => default based on quantity (common desired preload behavior)
      active: typeof t.active === "boolean" ? t.active : quantity > 0,
    }));

    return {
      ...a,
      squareFootages: [{ ...first, squareFt, quantity }],
      tasks: normalizedTasks,
    };
  });
};

export function cleanDescription(description = "") {
  return description
    .replace(/\s*@seed\b\s*/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}
